export const fonts = {
  body: 'gotham rounded,sans-serif',
  heading: 'gotham rounded,sans-serif',
}

export const fontWeights = {
  body: 300,
  normal: 300,
  medium: 300,
  bold: 400,
}
